import { useEffect, useState } from "react";
import { Table, Tag, message } from "antd";
import { useNavigate } from "react-router-dom"; 
import { getWorkflowRecordsApi } from "../../../apiservice/ats";

export default function WorkflowRecords() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const loadRecords = async () => {
    try {
      setLoading(true);
      const res = await getWorkflowRecordsApi();
      setRecords(res.data || []);
    } catch {
      message.error("Failed to load workflow records");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadRecords();
  }, []);

    const columns = [
    {
        title: "Record",
        render: (_, r) => (
        <span
            style={{ cursor: "pointer" }}
            onClick={() =>
            navigate(`/ats/tasks/${r.record_type}/${r.record_id}`)
            }
        >
            <Tag color="blue">
            {r.record_type} - {r.record_id}
            </Tag>
        </span>
        ),
    },
    {
        title: "Total Tasks",
        dataIndex: "task_count",
        width: 120,
    },
    ];

  return (
    <Table
      rowKey={(r) => `${r.record_type}-${r.record_id}`}
      loading={loading}
      dataSource={records}
      columns={columns}
      bordered
      onRow={(record) => ({
        onClick: () =>
          navigate(
            `/ats/tasks/${record.record_type}/${record.record_id}`
          ),
      })}
    />
  );
}
